import { Version } from '@src/@fuse/version/version';

export const FUSE_VERSION = new Version('13.6.2').full;
